import { useSetAtom } from 'jotai';

import { useTranslate } from '@growtherapy/i18n';
import { Button, Text } from '@growtherapy/sprout-ui';

import { preSessionVibesOpenAtom, visitorDrawerStateAtom } from '../../state';
import { useBackgroundMusicPlayback } from '../background-action/useBackgroundMusicPlayback';

export type VibesCtaProps = {
  openPreSessionVibes: () => void;
};

export function VibesCta({ openPreSessionVibes }: VibesCtaProps) {
  const t = useTranslate();
  return (
    <>
      <Text data-testid='pre-session-prompt-vibes' className='font-medium'>
        {t('telehealth-core:waitingRoom.inTheMeantimeTakeAMomentTo')}
      </Text>
      <Button
        className='flex gap-4 justify-center items-center w-full rebrand:w-component-700'
        onClick={openPreSessionVibes}
      >
        {t('telehealth-core:waitingRoom.unwindWhileYouWait')}
      </Button>
    </>
  );
}

export function VibesCtaWrapper() {
  const setPreSessionVibesOpen = useSetAtom(preSessionVibesOpenAtom);
  const setDrawerState = useSetAtom(visitorDrawerStateAtom);
  const { handlePlay } = useBackgroundMusicPlayback();
  const openPreSessionVibes = () => {
    setDrawerState(null);
    setPreSessionVibesOpen(true);
    handlePlay();
  };

  return <VibesCta openPreSessionVibes={openPreSessionVibes} />;
}
